export default __webpack_public_path__ + "static/form-default-values-dont-9e1f0b47cc923a8fd43c62f4d634d0a739b07bc6363b2c74fc1e650b56fe3b9c.png";